import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
interface AccordionItem {
  question: string;
  answer: string;
}
interface AccordionProps {
  items: AccordionItem[];
  className?: string;
}
export function Accordion({
  items,
  className = ''
}: AccordionProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return <div className={`space-y-4 ${className}`} data-id="element-87">
      {items.map((item, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-white hover:border-navy-200 transition-colors" data-id="element-88">
          <button onClick={() => toggleItem(index)} className="flex items-center justify-between w-full p-5 text-left focus:outline-none" aria-expanded={activeIndex === index} data-id="element-89">
            <span className="text-lg font-medium text-slate-900" data-id="element-90">
              {item.question}
            </span>
            <span className={`ml-4 flex-shrink-0 text-navy-600 transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} data-id="element-91">
              {activeIndex === index ? <Minus size={20} data-id="element-92" /> : <Plus size={20} data-id="element-93" />}
            </span>
          </button>

          <AnimatePresence data-id="element-94">
            {activeIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-95">
                <div className="px-5 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-4" data-id="element-96">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}